import { render, staticRenderFns } from "./AzulDashboard.vue?vue&type=template&id=24d2b1fa&scoped=true"
import script from "./AzulDashboard.vue?vue&type=script&lang=js"
export * from "./AzulDashboard.vue?vue&type=script&lang=js"
import style0 from "./AzulDashboard.vue?vue&type=style&index=0&id=24d2b1fa&prod&scoped=true&lang=scss"
import style1 from "../Dashboard/styles.scss?vue&type=style&index=1&id=24d2b1fa&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d2b1fa",
  null
  
)

export default component.exports